import { IconProps } from "../types"
import React from "react"

export const IconMagnifyingGlass: React.FC<IconProps> = ({
  className,
  height = 48,
  width = 48,
  strokeWidth = 3.5,
  strokeColor = "currentColor",
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 48 48"
  >
    <path
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M44.5 44.5L33.728 33.728m0 0A17.943 17.943 0 0039 21c0-9.941-8.059-18-18-18S3 11.059 3 21s8.059 18 18 18c4.97 0 9.47-2.015 12.728-5.272z"
    ></path>
  </svg>
)
